document.addEventListener('DOMContentLoaded', function () {
    const productSwitcher = document.getElementById('productSwitcher');
    const ambienceSwitcher = document.getElementById('ambienceSwitcher');
    const productImages = document.querySelectorAll('.collection-image.o-product-image');
    const ambienceImages = document.querySelectorAll('.collection-image.ambience-image');

    // localStorage key for storing the active state
    const STORAGE_KEY = 'cob-products-overview-active-type';

    function updateVisibility(activeType) {
        if (activeType === 'product') {
            productImages.forEach((image) => (image.style.display = 'block'));
            ambienceImages.forEach((image) => (image.style.display = 'none'));
            if (productSwitcher) {
                productSwitcher.classList.add('active');
            }
            if (ambienceSwitcher) {
                ambienceSwitcher.classList.remove('active');
            }
        } else {
            ambienceImages.forEach((image) => (image.style.display = 'block'));
            productImages.forEach((image) => (image.style.display = 'none'));
            if (ambienceSwitcher) {
                ambienceSwitcher.classList.add('active');
            }
            if (productSwitcher) {
                productSwitcher.classList.remove('active');
            }
        }

        // Save the active state to localStorage
        localStorage.setItem(STORAGE_KEY, activeType);
    }

    if (productSwitcher) {
        productSwitcher.addEventListener('click', function () {
            updateVisibility('product');
            // Re-initialize hover functionality with new state
            addHoverFunctionality();
        });
    }

    if (ambienceSwitcher) {
        ambienceSwitcher.addEventListener('click', function () {
            updateVisibility('ambience');
            // Re-initialize hover functionality with new state
            addHoverFunctionality();
        });
    }

    // Add hover functionality for each image container
    function addHoverFunctionality() {
        const imageContainers = document.querySelectorAll('.cms-category-image');

        imageContainers.forEach((container) => {
            const productImage = container.querySelector('.collection-image.o-product-image');
            const ambienceImage = container.querySelector('.collection-image.ambience-image');

            if (productImage && ambienceImage) {
                // Remove existing event listeners to avoid duplication
                const oldMouseEnter = container._hoverMouseEnter;
                const oldMouseLeave = container._hoverMouseLeave;
                if (oldMouseEnter) container.removeEventListener('mouseenter', oldMouseEnter);
                if (oldMouseLeave) container.removeEventListener('mouseleave', oldMouseLeave);

                // Create new event listeners
                const mouseEnterHandler = function () {
                    const currentActiveType = localStorage.getItem(STORAGE_KEY) || 'product';

                    // Show the opposite image type on hover
                    if (currentActiveType === 'product') {
                        // Currently showing product, show ambience on hover
                        productImage.style.display = 'none';
                        ambienceImage.style.display = 'block';
                    } else {
                        // Currently showing ambience, show product on hover
                        ambienceImage.style.display = 'none';
                        productImage.style.display = 'block';
                    }
                };

                const mouseLeaveHandler = function () {
                    const currentActiveType = localStorage.getItem(STORAGE_KEY) || 'product';

                    // Restore the original active state
                    if (currentActiveType === 'product') {
                        productImage.style.display = 'block';
                        ambienceImage.style.display = 'none';
                    } else {
                        ambienceImage.style.display = 'block';
                        productImage.style.display = 'none';
                    }
                };

                // Store references for later removal
                container._hoverMouseEnter = mouseEnterHandler;
                container._hoverMouseLeave = mouseLeaveHandler;

                // Add new event listeners
                container.addEventListener('mouseenter', mouseEnterHandler);
                container.addEventListener('mouseleave', mouseLeaveHandler);
            }
        });
    }

    // Initialize visibility on page load - check localStorage first
    if (productImages.length > 0 || ambienceImages.length > 0) {
        const savedActiveType = localStorage.getItem(STORAGE_KEY);
        const activeType = savedActiveType || 'product'; // fallback to 'product' if nothing saved
        updateVisibility(activeType);

        // Add hover functionality after initial setup
        addHoverFunctionality();
    }
});
